/*
 * This file is generated by graphql-codegen. Do NOT edit directly.
 * Run `npm run graphql:caire-api` to regenerate.
 */
import * as ServiceTypes from '@/lib/graphql/types';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = { ssr: false, fetchPolicy: 'network-only' } as const;
export type MarkTaskCompleteMutationVariables = ServiceTypes.Exact<{
  taskId: ServiceTypes.Scalars['UUID']['input'];
}>;

export type MarkTaskCompleteMutation = {
  __typename?: 'Mutation';
  markTaskComplete: {
    __typename?: 'Task';
    id: any;
    status: ServiceTypes.TaskStatus;
  };
};

export type CareGapTodoListQueryVariables = ServiceTypes.Exact<{
  [key: string]: never;
}>;

export type CareGapTodoListQuery = {
  __typename?: 'Query';
  careJourneys: Array<{
    __typename?: 'CareJourney';
    id: any;
    sequentialTouchpoints?: Array<{
      __typename?: 'SequentialTouchpoint';
      id: any;
      updatedAt: any;
      careJourneyId: any;
      dueAt?: any | null;
      sequentialTouchpointTemplate?: {
        __typename?: 'SequentialTouchpointTemplate';
        id: any;
        name: string;
        description?: string | null;
        category: ServiceTypes.TouchpointCategory;
      } | null;
      task?: {
        __typename?: 'Task';
        id: any;
        relatedObjectId?: string | null;
        relatedObjectType?: ServiceTypes.TaskRelatedObject | null;
      } | null;
    }> | null;
  }>;
};

export type TouchpointCareGapTaskFragment = {
  __typename?: 'SequentialTouchpoint';
  id: any;
  updatedAt: any;
  careJourneyId: any;
  dueAt?: any | null;
  sequentialTouchpointTemplate?: {
    __typename?: 'SequentialTouchpointTemplate';
    id: any;
    name: string;
    description?: string | null;
    category: ServiceTypes.TouchpointCategory;
  } | null;
  task?: {
    __typename?: 'Task';
    id: any;
    relatedObjectId?: string | null;
    relatedObjectType?: ServiceTypes.TaskRelatedObject | null;
  } | null;
};

export type CreateMemberPatientMutationVariables = ServiceTypes.Exact<{
  input: ServiceTypes.CreatePatientWithMatchInput;
}>;

export type CreateMemberPatientMutation = {
  __typename?: 'Mutation';
  patient: { __typename?: 'Patient'; id: any };
};

export type CreatePatientMutationVariables = ServiceTypes.Exact<{
  input: ServiceTypes.CreatePatientInput;
}>;

export type CreatePatientMutation = {
  __typename?: 'Mutation';
  createPatient: {
    __typename?: 'Patient';
    id: any;
    firstName: string;
    lastName: string;
    birthDate: any;
    birthSex: ServiceTypes.BirthSex;
    preferredName?: string | null;
    contactPreference?: ServiceTypes.ContactPreference | null;
    addresses?: Array<{
      __typename?: 'Address';
      city: string;
      line1: string;
      line2?: string | null;
      state: ServiceTypes.StateCode;
      postalCode: string;
      country: string;
    }> | null;
    phoneNumbers?: Array<{
      __typename?: 'PhoneNumber';
      use: ServiceTypes.ContactUse;
      value: string;
    }> | null;
    pronouns?: {
      __typename?: 'Pronouns';
      value: ServiceTypes.PronounCode;
    } | null;
    genderIdentity?: {
      __typename?: 'GenderIdentity';
      value: ServiceTypes.GenderIdentityCode;
    } | null;
  };
};

export type EligibilityMatchQueryVariables = ServiceTypes.Exact<{
  input: ServiceTypes.CheckEligibilityInput;
}>;

export type EligibilityMatchQuery = {
  __typename?: 'Query';
  checkEligibility: {
    __typename?: 'CheckEligibilityOutput';
    matchId?: any | null;
    token?: string | null;
    ineligibleReason?: ServiceTypes.IneligibilityReason | null;
  };
};

export type ActiveCareJourneysItemFragment = {
  __typename?: 'CareJourney';
  id: any;
  status: ServiceTypes.CareJourneyStatus;
  careJourneyTemplateVersion: {
    __typename?: 'CareJourneyTemplateVersion';
    careJourneyTemplate: { __typename?: 'CareJourneyTemplate'; name: string };
  };
};

export type ActiveCareJourneysQueryVariables = ServiceTypes.Exact<{
  [key: string]: never;
}>;

export type ActiveCareJourneysQuery = {
  __typename?: 'Query';
  ongoing: Array<{
    __typename?: 'CareJourney';
    id: any;
    status: ServiceTypes.CareJourneyStatus;
    careJourneyTemplateVersion: {
      __typename?: 'CareJourneyTemplateVersion';
      careJourneyTemplate: { __typename?: 'CareJourneyTemplate'; name: string };
    };
  }>;
  eventDriven: Array<{
    __typename?: 'CareJourney';
    id: any;
    status: ServiceTypes.CareJourneyStatus;
    careJourneyTemplateVersion: {
      __typename?: 'CareJourneyTemplateVersion';
      careJourneyTemplate: { __typename?: 'CareJourneyTemplate'; name: string };
    };
  }>;
};

export type AgentConfigQueryVariables = ServiceTypes.Exact<{
  domain: ServiceTypes.Scalars['String']['input'];
}>;

export type AgentConfigQuery = {
  __typename?: 'Query';
  tenant?: {
    __typename?: 'PublicTenant';
    id: any;
    agentConfig?: {
      __typename?: 'AgentConfig';
      agentName: string;
      greetingMessage: string;
    } | null;
  } | null;
};

export type RecommendedForYouContentIdsQueryVariables = ServiceTypes.Exact<{
  [key: string]: never;
}>;

export type RecommendedForYouContentIdsQuery = {
  __typename?: 'Query';
  careJourneys: Array<{
    __typename?: 'CareJourney';
    id: any;
    sequentialTouchpoints?: Array<{
      __typename?: 'SequentialTouchpoint';
      id: any;
      task?: {
        __typename?: 'Task';
        id: any;
        relatedObjectId?: string | null;
        relatedObjectType?: ServiceTypes.TaskRelatedObject | null;
      } | null;
    }> | null;
  }>;
};

export type SupportContactInformationQueryVariables = ServiceTypes.Exact<{
  tenantDomain: ServiceTypes.Scalars['String']['input'];
}>;

export type SupportContactInformationQuery = {
  __typename?: 'Query';
  tenant?: { __typename?: 'PublicTenant'; supportEmail: string } | null;
};

export type UserAddressQueryVariables = ServiceTypes.Exact<{
  [key: string]: never;
}>;

export type UserAddressQuery = {
  __typename?: 'Query';
  whoAmI: {
    __typename?: 'Patient';
    id: any;
    addresses?: Array<{
      __typename?: 'Address';
      city: string;
      line1: string;
      line2?: string | null;
      state: ServiceTypes.StateCode;
      postalCode: string;
      country: string;
    }> | null;
  };
};

export type UserExistsQueryVariables = ServiceTypes.Exact<{
  [key: string]: never;
}>;

export type UserExistsQuery = {
  __typename?: 'Query';
  whoAmI: {
    __typename?: 'Patient';
    id: any;
    enrollments: Array<{
      __typename?: 'Enrollment';
      id: string;
      programId: any;
    }>;
  };
};

export type UserProfileQueryVariables = ServiceTypes.Exact<{
  [key: string]: never;
}>;

export type UserProfileQuery = {
  __typename?: 'Query';
  whoAmI: {
    __typename?: 'Patient';
    id: any;
    firstName: string;
    lastName: string;
    birthDate: any;
    birthSex: ServiceTypes.BirthSex;
    createdAt: any;
    updatedAt: any;
    preferredName?: string | null;
    contactPreference?: ServiceTypes.ContactPreference | null;
    genderIdentity?: {
      __typename?: 'GenderIdentity';
      text: string;
      value: ServiceTypes.GenderIdentityCode;
    } | null;
    phoneNumbers?: Array<{
      __typename?: 'PhoneNumber';
      use: ServiceTypes.ContactUse;
      value: string;
    }> | null;
    pronouns?: {
      __typename?: 'Pronouns';
      text: string;
      value: ServiceTypes.PronounCode;
    } | null;
  };
};

export type WhoAmIQueryVariables = ServiceTypes.Exact<{ [key: string]: never }>;

export type WhoAmIQuery = {
  __typename?: 'Query';
  whoAmI: {
    __typename?: 'Patient';
    id: any;
    firstName: string;
    lastName: string;
    birthDate: any;
    birthSex: ServiceTypes.BirthSex;
    preferredName?: string | null;
    contactPreference?: ServiceTypes.ContactPreference | null;
    genderIdentity?: {
      __typename?: 'GenderIdentity';
      text: string;
      value: ServiceTypes.GenderIdentityCode;
    } | null;
    phoneNumbers?: Array<{
      __typename?: 'PhoneNumber';
      use: ServiceTypes.ContactUse;
      value: string;
    }> | null;
    emailAddresses?: Array<{
      __typename?: 'EmailAddress';
      value: string;
    }> | null;
    pronouns?: {
      __typename?: 'Pronouns';
      text: string;
      value: ServiceTypes.PronounCode;
    } | null;
    addresses?: Array<{
      __typename?: 'Address';
      city: string;
      line1: string;
      line2?: string | null;
      state: ServiceTypes.StateCode;
      postalCode: string;
      country: string;
    }> | null;
    member?: { __typename?: 'Member'; id: any; cohort?: string | null } | null;
    enrollments: Array<{
      __typename?: 'Enrollment';
      id: string;
      programId: any;
      enrollmentStatus: ServiceTypes.EnrollmentStatus;
      program: {
        __typename?: 'Program';
        id: any;
        name: string;
        slug: string;
        config?: {
          __typename?: 'ProgramConfigResponse';
          roleNameMapping?: any | null;
        } | null;
      };
    }>;
    careJourneys?: Array<{
      __typename?: 'CareJourney';
      id: any;
      status: ServiceTypes.CareJourneyStatus;
      careJourneyTemplateVersion: {
        __typename?: 'CareJourneyTemplateVersion';
        careJourneyTemplate: {
          __typename?: 'CareJourneyTemplate';
          name: string;
        };
      };
    }> | null;
  };
};

export type GuidedJourneyReadPositionDetailsFragment = {
  __typename?: 'ContentView';
  id: any;
  createdAt: any;
  contentType: ServiceTypes.ContentfulContentType;
  contentId: string;
  parentContentId?: string | null;
  parentContentType?: ServiceTypes.ContentfulContentType | null;
  isContentAssignmentComplete: boolean;
  taskId?: any | null;
};

export type TouchpointDetailFragment = {
  __typename?: 'SequentialTouchpoint';
  id: any;
  labelDate?: any | null;
  dueAt?: any | null;
  completedAt?: any | null;
  updatedAt: any;
  position: number;
  note?: string | null;
  status: ServiceTypes.TouchpointStatus;
  tasks?: Array<{
    __typename?: 'Task';
    id: any;
    name: string;
    taskDueAt: any;
    taskType: ServiceTypes.TaskType;
    relatedObjectId?: string | null;
    relatedObjectType?: ServiceTypes.TaskRelatedObject | null;
    status: ServiceTypes.TaskStatus;
  }> | null;
  sequentialTouchpointTemplate?: {
    __typename?: 'SequentialTouchpointTemplate';
    category: ServiceTypes.TouchpointCategory;
    type?: ServiceTypes.TouchpointType | null;
    name: string;
    description?: string | null;
    touchpointFrequency?: {
      __typename?: 'TouchpointCadence';
      numberOfRepeats?: number | null;
      frequency: {
        __typename?: 'Frequency';
        duration: ServiceTypes.FrequencyDuration;
        value: number;
      };
    } | null;
    taskFrequency?: {
      __typename?: 'TaskCadence';
      numberOfRepeats?: number | null;
      frequency: {
        __typename?: 'Frequency';
        duration: ServiceTypes.FrequencyDuration;
        value: number;
      };
    } | null;
  } | null;
};

export type MarkGuidedJourneyCompleteMutationVariables = ServiceTypes.Exact<{
  patientId: ServiceTypes.Scalars['UUID']['input'];
  programId: ServiceTypes.Scalars['UUID']['input'];
  id: ServiceTypes.Scalars['String']['input'];
  guidedJourneyId: ServiceTypes.Scalars['String']['input'];
  taskId?: ServiceTypes.InputMaybe<ServiceTypes.Scalars['UUID']['input']>;
}>;

export type MarkGuidedJourneyCompleteMutation = {
  __typename?: 'Mutation';
  createContentView: { __typename?: 'ContentView'; id: any; contentId: string };
};

export type MarkGuidedJourneyPageReadMutationVariables = ServiceTypes.Exact<{
  patientId: ServiceTypes.Scalars['UUID']['input'];
  programId: ServiceTypes.Scalars['UUID']['input'];
  id: ServiceTypes.Scalars['String']['input'];
  guidedJourneyId: ServiceTypes.Scalars['String']['input'];
  taskId?: ServiceTypes.InputMaybe<ServiceTypes.Scalars['UUID']['input']>;
}>;

export type MarkGuidedJourneyPageReadMutation = {
  __typename?: 'Mutation';
  createContentView: { __typename?: 'ContentView'; id: any; contentId: string };
};

export type MarkPageReadMutationVariables = ServiceTypes.Exact<{
  patientId: ServiceTypes.Scalars['UUID']['input'];
  programId: ServiceTypes.Scalars['UUID']['input'];
  id: ServiceTypes.Scalars['String']['input'];
  taskId?: ServiceTypes.InputMaybe<ServiceTypes.Scalars['UUID']['input']>;
  markTaskComplete?: ServiceTypes.InputMaybe<
    ServiceTypes.Scalars['Boolean']['input']
  >;
}>;

export type MarkPageReadMutation = {
  __typename?: 'Mutation';
  createContentView: { __typename?: 'ContentView'; id: any; contentId: string };
};

export type UpsertFormResponseByTaskIdMutationVariables = ServiceTypes.Exact<{
  taskId: ServiceTypes.Scalars['UUID']['input'];
  input: ServiceTypes.UpsertFormResponseInput;
}>;

export type UpsertFormResponseByTaskIdMutation = {
  __typename?: 'Mutation';
  upsertFormResponseByTaskId: {
    __typename?: 'FormResponse';
    id: any;
    patientId: any;
    programId: any;
    formVersionId: any;
    response?: any | null;
    createdAt: any;
    updatedAt: any;
    submittedAt?: any | null;
    task?: { __typename?: 'Task'; id: any } | null;
    formVersion: { __typename?: 'FormVersion'; id: any };
  };
};

export type ResetUserPasswordMutationVariables = ServiceTypes.Exact<{
  resetUserPasswordId: ServiceTypes.Scalars['UUID']['input'];
}>;

export type ResetUserPasswordMutation = {
  __typename?: 'Mutation';
  resetUserPassword?: any | null;
};

export type UpdatePatientMutationVariables = ServiceTypes.Exact<{
  updatePatientId: ServiceTypes.Scalars['UUID']['input'];
  input: ServiceTypes.UpdatePatientInput;
}>;

export type UpdatePatientMutation = {
  __typename?: 'Mutation';
  updatePatient: { __typename?: 'Patient'; firstName: string };
};

export type UpsertNotificationProfileMutationVariables = ServiceTypes.Exact<{
  input: ServiceTypes.NotificationProfileInput;
}>;

export type UpsertNotificationProfileMutation = {
  __typename?: 'Mutation';
  upsertNotificationProfile: {
    __typename?: 'NotificationProfile';
    healthCommunicationsOptPreference?: {
      __typename?: 'NotificationOptInPreference';
      email: ServiceTypes.CommunicationOptPreference;
      sms: ServiceTypes.CommunicationOptPreference;
    } | null;
  };
};

export type GuidedJourneyReadPositionQueryVariables = ServiceTypes.Exact<{
  patientId: ServiceTypes.Scalars['UUID']['input'];
  programId: ServiceTypes.Scalars['UUID']['input'];
  guidedJourneyId: ServiceTypes.Scalars['String']['input'];
  taskId?: ServiceTypes.InputMaybe<ServiceTypes.Scalars['UUID']['input']>;
}>;

export type GuidedJourneyReadPositionQuery = {
  __typename?: 'Query';
  contentViews: Array<{
    __typename?: 'ContentView';
    id: any;
    createdAt: any;
    contentType: ServiceTypes.ContentfulContentType;
    contentId: string;
    parentContentId?: string | null;
    parentContentType?: ServiceTypes.ContentfulContentType | null;
    isContentAssignmentComplete: boolean;
    taskId?: any | null;
  }>;
};

export type NotificationProfileQueryVariables = ServiceTypes.Exact<{
  patientId: ServiceTypes.Scalars['UUID']['input'];
}>;

export type NotificationProfileQuery = {
  __typename?: 'Query';
  patientNotificationProfile: {
    __typename?: 'NotificationProfile';
    healthCommunicationsOptPreference?: {
      __typename?: 'NotificationOptInPreference';
      email: ServiceTypes.CommunicationOptPreference;
      sms: ServiceTypes.CommunicationOptPreference;
    } | null;
  };
};

export type GetFormByIdQueryVariables = ServiceTypes.Exact<{
  formId: ServiceTypes.Scalars['UUID']['input'];
}>;

export type GetFormByIdQuery = {
  __typename?: 'Query';
  form: {
    __typename?: 'Form';
    id: any;
    archivedAt?: any | null;
    createdAt: any;
    description?: string | null;
    name: string;
    programId: any;
    slug: string;
    updatedAt: any;
    draftVersion: { __typename?: 'FormVersion'; config: any; id: any };
    publishedVersion?: {
      __typename?: 'FormVersion';
      config: any;
      id: any;
    } | null;
  };
};

export type GetFormResponseByTaskIdQueryVariables = ServiceTypes.Exact<{
  taskId: ServiceTypes.Scalars['UUID']['input'];
}>;

export type GetFormResponseByTaskIdQuery = {
  __typename?: 'Query';
  formResponseByTaskId?: {
    __typename?: 'FormResponse';
    id: any;
    response?: any | null;
    pageNumber?: number | null;
  } | null;
};

export type PatientMemberBenefitsQueryVariables = ServiceTypes.Exact<{
  patientId: ServiceTypes.Scalars['UUID']['input'];
}>;

export type PatientMemberBenefitsQuery = {
  __typename?: 'Query';
  patientMember?: {
    __typename?: 'Member';
    id: any;
    additionalBenefits: Array<{
      __typename?: 'EmployerAdditionalBenefits';
      accessCode?: string | null;
      description: string;
      name: string;
      url?: string | null;
    }>;
  } | null;
};

export type ConceptsPractitionersAutocompleteQueryVariables =
  ServiceTypes.Exact<{
    query: ServiceTypes.Scalars['String']['input'];
  }>;

export type ConceptsPractitionersAutocompleteQuery = {
  __typename?: 'Query';
  conceptsPractitionersAutocomplete: {
    __typename?: 'ConceptsPractitionersSearchResults';
    concepts: Array<{
      __typename?: 'ConceptSearchResult';
      value: string;
      type: string;
      id: any;
    }>;
    practitioners: Array<{
      __typename?: 'PractitionerSearchResult';
      displayName: string;
      id: any;
    }>;
  };
};

export type FacilitiesNearQueryVariables = ServiceTypes.Exact<{
  filters: ServiceTypes.FilterNearFacilitiesParams;
  pagination?: ServiceTypes.InputMaybe<ServiceTypes.PaginationParams>;
}>;

export type FacilitiesNearQuery = {
  __typename?: 'Query';
  facilitiesNear: {
    __typename?: 'FacilitiesNearList';
    totalCount: number;
    items: Array<{
      __typename?: 'FacilityNearResult';
      distance: number;
      facility: {
        __typename?: 'Facility';
        name: string;
        type?: string | null;
        phoneNumber: string;
        id: any;
      };
      address: {
        __typename?: 'FacilityAddress';
        geoLocation: string;
        accessible: boolean;
        city: string;
        addressLine2?: string | null;
        addressLine1: string;
        state: string;
        zipCode: string;
      };
    }>;
  };
};

export type FacilityQueryVariables = ServiceTypes.Exact<{
  facilityId: ServiceTypes.Scalars['UUID']['input'];
}>;

export type FacilityQuery = {
  __typename?: 'Query';
  facility: {
    __typename?: 'Facility';
    id: any;
    name: string;
    phoneNumber: string;
    accessible: boolean;
    city: string;
    addressLine1: string;
    addressLine2?: string | null;
    geoLocation: string;
    type?: string | null;
    zipCode: string;
  };
};

export type NetworksQueryVariables = ServiceTypes.Exact<{
  [key: string]: never;
}>;

export type NetworksQuery = {
  __typename?: 'Query';
  networks: Array<{ __typename?: 'Network'; id: any; name: string }>;
};

export type PatientMemberNetworkIdQueryVariables = ServiceTypes.Exact<{
  patientId: ServiceTypes.Scalars['UUID']['input'];
}>;

export type PatientMemberNetworkIdQuery = {
  __typename?: 'Query';
  patientMember?: {
    __typename?: 'Member';
    id: any;
    employer: { __typename?: 'Employer'; id: any; networkId: any };
  } | null;
};

export type PatientMemberWrapNetworkQueryVariables = ServiceTypes.Exact<{
  patientId: ServiceTypes.Scalars['UUID']['input'];
}>;

export type PatientMemberWrapNetworkQuery = {
  __typename?: 'Query';
  patientMember?: {
    __typename?: 'Member';
    employer: {
      __typename?: 'Employer';
      wrapNetworkUrl?: string | null;
      wrapNetworkName?: string | null;
    };
  } | null;
};

export type PractitionerQueryVariables = ServiceTypes.Exact<{
  practitionerId: ServiceTypes.Scalars['UUID']['input'];
}>;

export type PractitionerQuery = {
  __typename?: 'Query';
  practitioner: {
    __typename?: 'Practitioner';
    id: any;
    lastName: string;
    firstName: string;
    title?: string | null;
    suffix?: string | null;
    languages?: Array<string> | null;
    genderIdentity?: {
      __typename?: 'GenderIdentity';
      text: string;
      value: ServiceTypes.GenderIdentityCode;
    } | null;
    specialties: Array<{
      __typename?: 'PractitionerSpecialty';
      primary: boolean;
      id: any;
      boardCertified: boolean;
      specialty: { __typename?: 'Specialty'; name: string };
    }>;
    addresses: Array<{
      __typename?: 'PractitionerAddress';
      name?: string | null;
      telemedicineCapable?: boolean | null;
      acceptingNewPatients?: boolean | null;
      addressLine1: string;
      addressLine2?: string | null;
      city: string;
      schedulingUrl?: string | null;
      geoLocation?: string | null;
      phone: string;
      zipCode: string;
    }>;
  };
};

export type PractitionersNearQueryVariables = ServiceTypes.Exact<{
  filters: ServiceTypes.FilterNearPractitionerParams;
  pagination?: ServiceTypes.InputMaybe<ServiceTypes.PaginationParams>;
}>;

export type PractitionersNearQuery = {
  __typename?: 'Query';
  practitionersNear: {
    __typename?: 'PractitionersNearList';
    totalCount: number;
    items: Array<{
      __typename?: 'PractitionerNearResult';
      distance: number;
      address: {
        __typename?: 'PractitionerAddress';
        id: any;
        addressLine1: string;
        addressLine2?: string | null;
        city: string;
        phone: string;
        zipCode: string;
        schedulingUrl?: string | null;
      };
      practitioner: {
        __typename?: 'Practitioner';
        id: any;
        firstName: string;
        lastName: string;
        title?: string | null;
        suffix?: string | null;
        specialties: Array<{
          __typename?: 'PractitionerSpecialty';
          primary: boolean;
          specialty: { __typename?: 'Specialty'; name: string };
        }>;
        addresses: Array<{
          __typename?: 'PractitionerAddress';
          id: any;
          addressLine1: string;
          addressLine2?: string | null;
          city: string;
          phone: string;
          zipCode: string;
          schedulingUrl?: string | null;
          geoLocation?: string | null;
        }>;
      };
    }>;
  };
};

export type SpecialtyQueryVariables = ServiceTypes.Exact<{
  specialtyId: ServiceTypes.Scalars['UUID']['input'];
}>;

export type SpecialtyQuery = {
  __typename?: 'Query';
  specialty: { __typename?: 'Specialty'; name: string; id: any };
};

export type TaskQueryVariables = ServiceTypes.Exact<{
  taskId: ServiceTypes.Scalars['UUID']['input'];
}>;

export type TaskQuery = {
  __typename?: 'Query';
  task: { __typename?: 'Task'; id: any; eventDueAt?: any | null };
};

export type TaskObjectRouteQueryVariables = ServiceTypes.Exact<{
  taskId: ServiceTypes.Scalars['UUID']['input'];
}>;

export type TaskObjectRouteQuery = {
  __typename?: 'Query';
  task: {
    __typename?: 'Task';
    id: any;
    name: string;
    status: ServiceTypes.TaskStatus;
    taskDueAt: any;
    taskExpireAt?: any | null;
    taskType: ServiceTypes.TaskType;
    relatedObjectType?: ServiceTypes.TaskRelatedObject | null;
    relatedObjectId?: string | null;
  };
};

export type TenantPoliciesQueryVariables = ServiceTypes.Exact<{
  domain: ServiceTypes.Scalars['String']['input'];
}>;

export type TenantPoliciesQuery = {
  __typename?: 'Query';
  tenant?: {
    __typename?: 'PublicTenant';
    id: any;
    policiesConfig?: Array<{
      __typename?: 'PoliciesConfig';
      slug: string;
      url: string;
    }> | null;
  } | null;
};

export type TimelineTouchpointsQueryVariables = ServiceTypes.Exact<{
  pastTouchpointsFilters: ServiceTypes.FilterSequentialTouchpointParams;
  pastTouchpointsPagination?: ServiceTypes.InputMaybe<ServiceTypes.PaginationParams>;
  pastTouchpointsSorting?: ServiceTypes.InputMaybe<
    Array<ServiceTypes.SortTouchpointParam>
  >;
  currentTouchpointsFilters: ServiceTypes.FilterSequentialTouchpointParams;
  currentTouchpointsPagination?: ServiceTypes.InputMaybe<ServiceTypes.PaginationParams>;
  currentTouchpointsSorting?: ServiceTypes.InputMaybe<
    Array<ServiceTypes.SortTouchpointParam>
  >;
  incomingTouchpointsFilters: ServiceTypes.FilterSequentialTouchpointParams;
  incomingTouchpointsPagination?: ServiceTypes.InputMaybe<ServiceTypes.PaginationParams>;
  incomingTouchpointsSorting?: ServiceTypes.InputMaybe<
    Array<ServiceTypes.SortTouchpointParam>
  >;
}>;

export type TimelineTouchpointsQuery = {
  __typename?: 'Query';
  pastTouchpoints: {
    __typename?: 'SequentialTouchpointList';
    totalCount: number;
    items: Array<{
      __typename?: 'SequentialTouchpoint';
      id: any;
      labelDate?: any | null;
      dueAt?: any | null;
      completedAt?: any | null;
      updatedAt: any;
      position: number;
      note?: string | null;
      status: ServiceTypes.TouchpointStatus;
      tasks?: Array<{
        __typename?: 'Task';
        id: any;
        name: string;
        taskDueAt: any;
        taskType: ServiceTypes.TaskType;
        relatedObjectId?: string | null;
        relatedObjectType?: ServiceTypes.TaskRelatedObject | null;
        status: ServiceTypes.TaskStatus;
      }> | null;
      sequentialTouchpointTemplate?: {
        __typename?: 'SequentialTouchpointTemplate';
        category: ServiceTypes.TouchpointCategory;
        type?: ServiceTypes.TouchpointType | null;
        name: string;
        description?: string | null;
        touchpointFrequency?: {
          __typename?: 'TouchpointCadence';
          numberOfRepeats?: number | null;
          frequency: {
            __typename?: 'Frequency';
            duration: ServiceTypes.FrequencyDuration;
            value: number;
          };
        } | null;
        taskFrequency?: {
          __typename?: 'TaskCadence';
          numberOfRepeats?: number | null;
          frequency: {
            __typename?: 'Frequency';
            duration: ServiceTypes.FrequencyDuration;
            value: number;
          };
        } | null;
      } | null;
    }>;
  };
  currentTouchpoints: {
    __typename?: 'SequentialTouchpointList';
    totalCount: number;
    items: Array<{
      __typename?: 'SequentialTouchpoint';
      id: any;
      labelDate?: any | null;
      dueAt?: any | null;
      completedAt?: any | null;
      updatedAt: any;
      position: number;
      note?: string | null;
      status: ServiceTypes.TouchpointStatus;
      tasks?: Array<{
        __typename?: 'Task';
        id: any;
        name: string;
        taskDueAt: any;
        taskType: ServiceTypes.TaskType;
        relatedObjectId?: string | null;
        relatedObjectType?: ServiceTypes.TaskRelatedObject | null;
        status: ServiceTypes.TaskStatus;
      }> | null;
      sequentialTouchpointTemplate?: {
        __typename?: 'SequentialTouchpointTemplate';
        category: ServiceTypes.TouchpointCategory;
        type?: ServiceTypes.TouchpointType | null;
        name: string;
        description?: string | null;
        touchpointFrequency?: {
          __typename?: 'TouchpointCadence';
          numberOfRepeats?: number | null;
          frequency: {
            __typename?: 'Frequency';
            duration: ServiceTypes.FrequencyDuration;
            value: number;
          };
        } | null;
        taskFrequency?: {
          __typename?: 'TaskCadence';
          numberOfRepeats?: number | null;
          frequency: {
            __typename?: 'Frequency';
            duration: ServiceTypes.FrequencyDuration;
            value: number;
          };
        } | null;
      } | null;
    }>;
  };
  incomingTouchpoints: {
    __typename?: 'SequentialTouchpointList';
    totalCount: number;
    items: Array<{
      __typename?: 'SequentialTouchpoint';
      id: any;
      labelDate?: any | null;
      dueAt?: any | null;
      completedAt?: any | null;
      updatedAt: any;
      position: number;
      note?: string | null;
      status: ServiceTypes.TouchpointStatus;
      tasks?: Array<{
        __typename?: 'Task';
        id: any;
        name: string;
        taskDueAt: any;
        taskType: ServiceTypes.TaskType;
        relatedObjectId?: string | null;
        relatedObjectType?: ServiceTypes.TaskRelatedObject | null;
        status: ServiceTypes.TaskStatus;
      }> | null;
      sequentialTouchpointTemplate?: {
        __typename?: 'SequentialTouchpointTemplate';
        category: ServiceTypes.TouchpointCategory;
        type?: ServiceTypes.TouchpointType | null;
        name: string;
        description?: string | null;
        touchpointFrequency?: {
          __typename?: 'TouchpointCadence';
          numberOfRepeats?: number | null;
          frequency: {
            __typename?: 'Frequency';
            duration: ServiceTypes.FrequencyDuration;
            value: number;
          };
        } | null;
        taskFrequency?: {
          __typename?: 'TaskCadence';
          numberOfRepeats?: number | null;
          frequency: {
            __typename?: 'Frequency';
            duration: ServiceTypes.FrequencyDuration;
            value: number;
          };
        } | null;
      } | null;
    }>;
  };
};

export const TouchpointCareGapTaskFragmentDoc = gql`
  fragment TouchpointCareGapTask on SequentialTouchpoint {
    id
    updatedAt
    careJourneyId
    dueAt
    sequentialTouchpointTemplate {
      id
      name
      description
      category
    }
    task {
      id
      relatedObjectId
      relatedObjectType
    }
  }
`;
export const ActiveCareJourneysItemFragmentDoc = gql`
  fragment ActiveCareJourneysItem on CareJourney {
    id
    status
    careJourneyTemplateVersion {
      careJourneyTemplate {
        name
      }
    }
  }
`;
export const GuidedJourneyReadPositionDetailsFragmentDoc = gql`
  fragment GuidedJourneyReadPositionDetails on ContentView {
    id
    createdAt
    contentType
    contentId
    parentContentId
    parentContentType
    isContentAssignmentComplete
    taskId
  }
`;
export const TouchpointDetailFragmentDoc = gql`
  fragment TouchpointDetail on SequentialTouchpoint {
    id
    labelDate
    dueAt
    completedAt
    updatedAt
    position
    note
    status
    tasks {
      id
      name
      taskDueAt
      taskType
      relatedObjectId
      relatedObjectType
      status
    }
    sequentialTouchpointTemplate {
      category
      type
      name
      description
      touchpointFrequency {
        numberOfRepeats
        frequency {
          duration
          value
        }
      }
      taskFrequency {
        numberOfRepeats
        frequency {
          duration
          value
        }
      }
    }
  }
`;
export const MarkTaskCompleteDocument = gql`
  mutation MarkTaskComplete($taskId: UUID!) {
    markTaskComplete(taskId: $taskId) {
      id
      status
    }
  }
`;
export type MarkTaskCompleteMutationFn = Apollo.MutationFunction<
  MarkTaskCompleteMutation,
  MarkTaskCompleteMutationVariables
>;

/**
 * __useMarkTaskCompleteMutation__
 *
 * To run a mutation, you first call `useMarkTaskCompleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkTaskCompleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markTaskCompleteMutation, { data, loading, error }] = useMarkTaskCompleteMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useMarkTaskCompleteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MarkTaskCompleteMutation,
    MarkTaskCompleteMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    MarkTaskCompleteMutation,
    MarkTaskCompleteMutationVariables
  >(MarkTaskCompleteDocument, options);
}
export type MarkTaskCompleteMutationHookResult = ReturnType<
  typeof useMarkTaskCompleteMutation
>;
export type MarkTaskCompleteMutationResult =
  Apollo.MutationResult<MarkTaskCompleteMutation>;
export type MarkTaskCompleteMutationOptions = Apollo.BaseMutationOptions<
  MarkTaskCompleteMutation,
  MarkTaskCompleteMutationVariables
>;
export const CareGapTodoListDocument = gql`
  query CareGapTodoList {
    careJourneys(filters: { careJourneyTemplateType: PREVENTATIVE }) {
      id
      sequentialTouchpoints(
        touchpointFilters: {
          statusRange: [OPEN, IN_PROGRESS]
          category: [APPOINTMENT, NON_INTEGRATED_APPOINTMENT, FORM]
        }
        touchpointSorting: { field: DUE_AT, order: ASC }
      ) {
        ...TouchpointCareGapTask
      }
    }
  }
  ${TouchpointCareGapTaskFragmentDoc}
`;

/**
 * __useCareGapTodoListQuery__
 *
 * To run a query within a React component, call `useCareGapTodoListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCareGapTodoListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCareGapTodoListQuery({
 *   variables: {
 *   },
 * });
 */
export function useCareGapTodoListQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CareGapTodoListQuery,
    CareGapTodoListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CareGapTodoListQuery, CareGapTodoListQueryVariables>(
    CareGapTodoListDocument,
    options
  );
}
export function useCareGapTodoListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CareGapTodoListQuery,
    CareGapTodoListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CareGapTodoListQuery,
    CareGapTodoListQueryVariables
  >(CareGapTodoListDocument, options);
}
export type CareGapTodoListQueryHookResult = ReturnType<
  typeof useCareGapTodoListQuery
>;
export type CareGapTodoListLazyQueryHookResult = ReturnType<
  typeof useCareGapTodoListLazyQuery
>;
export type CareGapTodoListQueryResult = Apollo.QueryResult<
  CareGapTodoListQuery,
  CareGapTodoListQueryVariables
>;
export const CreateMemberPatientDocument = gql`
  mutation CreateMemberPatient($input: CreatePatientWithMatchInput!) {
    patient: createPatientWithMatch(input: $input) {
      id
    }
  }
`;
export type CreateMemberPatientMutationFn = Apollo.MutationFunction<
  CreateMemberPatientMutation,
  CreateMemberPatientMutationVariables
>;

/**
 * __useCreateMemberPatientMutation__
 *
 * To run a mutation, you first call `useCreateMemberPatientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMemberPatientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMemberPatientMutation, { data, loading, error }] = useCreateMemberPatientMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMemberPatientMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateMemberPatientMutation,
    CreateMemberPatientMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateMemberPatientMutation,
    CreateMemberPatientMutationVariables
  >(CreateMemberPatientDocument, options);
}
export type CreateMemberPatientMutationHookResult = ReturnType<
  typeof useCreateMemberPatientMutation
>;
export type CreateMemberPatientMutationResult =
  Apollo.MutationResult<CreateMemberPatientMutation>;
export type CreateMemberPatientMutationOptions = Apollo.BaseMutationOptions<
  CreateMemberPatientMutation,
  CreateMemberPatientMutationVariables
>;
export const CreatePatientDocument = gql`
  mutation CreatePatient($input: CreatePatientInput!) {
    createPatient(input: $input) {
      id
      firstName
      lastName
      birthDate
      birthSex
      addresses {
        city
        line1
        line2
        state
        postalCode
        country
      }
      phoneNumbers {
        use
        value
      }
      preferredName
      pronouns {
        value
      }
      genderIdentity {
        value
      }
      contactPreference
    }
  }
`;
export type CreatePatientMutationFn = Apollo.MutationFunction<
  CreatePatientMutation,
  CreatePatientMutationVariables
>;

/**
 * __useCreatePatientMutation__
 *
 * To run a mutation, you first call `useCreatePatientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePatientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPatientMutation, { data, loading, error }] = useCreatePatientMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePatientMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreatePatientMutation,
    CreatePatientMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreatePatientMutation,
    CreatePatientMutationVariables
  >(CreatePatientDocument, options);
}
export type CreatePatientMutationHookResult = ReturnType<
  typeof useCreatePatientMutation
>;
export type CreatePatientMutationResult =
  Apollo.MutationResult<CreatePatientMutation>;
export type CreatePatientMutationOptions = Apollo.BaseMutationOptions<
  CreatePatientMutation,
  CreatePatientMutationVariables
>;
export const EligibilityMatchDocument = gql`
  query EligibilityMatch($input: CheckEligibilityInput!) {
    checkEligibility(input: $input) {
      matchId
      token
      ineligibleReason
    }
  }
`;

/**
 * __useEligibilityMatchQuery__
 *
 * To run a query within a React component, call `useEligibilityMatchQuery` and pass it any options that fit your needs.
 * When your component renders, `useEligibilityMatchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEligibilityMatchQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEligibilityMatchQuery(
  baseOptions: Apollo.QueryHookOptions<
    EligibilityMatchQuery,
    EligibilityMatchQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<EligibilityMatchQuery, EligibilityMatchQueryVariables>(
    EligibilityMatchDocument,
    options
  );
}
export function useEligibilityMatchLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    EligibilityMatchQuery,
    EligibilityMatchQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    EligibilityMatchQuery,
    EligibilityMatchQueryVariables
  >(EligibilityMatchDocument, options);
}
export type EligibilityMatchQueryHookResult = ReturnType<
  typeof useEligibilityMatchQuery
>;
export type EligibilityMatchLazyQueryHookResult = ReturnType<
  typeof useEligibilityMatchLazyQuery
>;
export type EligibilityMatchQueryResult = Apollo.QueryResult<
  EligibilityMatchQuery,
  EligibilityMatchQueryVariables
>;
export const ActiveCareJourneysDocument = gql`
  query ActiveCareJourneys {
    ongoing: careJourneys(
      filters: { careJourneyTemplateType: ONGOING, status: IN_PROGRESS }
    ) {
      ...ActiveCareJourneysItem
    }
    eventDriven: careJourneys(
      filters: { careJourneyTemplateType: EVENT_DRIVEN, status: IN_PROGRESS }
    ) {
      ...ActiveCareJourneysItem
    }
  }
  ${ActiveCareJourneysItemFragmentDoc}
`;

/**
 * __useActiveCareJourneysQuery__
 *
 * To run a query within a React component, call `useActiveCareJourneysQuery` and pass it any options that fit your needs.
 * When your component renders, `useActiveCareJourneysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveCareJourneysQuery({
 *   variables: {
 *   },
 * });
 */
export function useActiveCareJourneysQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ActiveCareJourneysQuery,
    ActiveCareJourneysQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ActiveCareJourneysQuery,
    ActiveCareJourneysQueryVariables
  >(ActiveCareJourneysDocument, options);
}
export function useActiveCareJourneysLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ActiveCareJourneysQuery,
    ActiveCareJourneysQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ActiveCareJourneysQuery,
    ActiveCareJourneysQueryVariables
  >(ActiveCareJourneysDocument, options);
}
export type ActiveCareJourneysQueryHookResult = ReturnType<
  typeof useActiveCareJourneysQuery
>;
export type ActiveCareJourneysLazyQueryHookResult = ReturnType<
  typeof useActiveCareJourneysLazyQuery
>;
export type ActiveCareJourneysQueryResult = Apollo.QueryResult<
  ActiveCareJourneysQuery,
  ActiveCareJourneysQueryVariables
>;
export const AgentConfigDocument = gql`
  query AgentConfig($domain: String!) {
    tenant: tenantByDomain(domain: $domain) {
      id
      agentConfig {
        agentName
        greetingMessage
      }
    }
  }
`;

/**
 * __useAgentConfigQuery__
 *
 * To run a query within a React component, call `useAgentConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgentConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgentConfigQuery({
 *   variables: {
 *      domain: // value for 'domain'
 *   },
 * });
 */
export function useAgentConfigQuery(
  baseOptions: Apollo.QueryHookOptions<
    AgentConfigQuery,
    AgentConfigQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AgentConfigQuery, AgentConfigQueryVariables>(
    AgentConfigDocument,
    options
  );
}
export function useAgentConfigLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AgentConfigQuery,
    AgentConfigQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AgentConfigQuery, AgentConfigQueryVariables>(
    AgentConfigDocument,
    options
  );
}
export type AgentConfigQueryHookResult = ReturnType<typeof useAgentConfigQuery>;
export type AgentConfigLazyQueryHookResult = ReturnType<
  typeof useAgentConfigLazyQuery
>;
export type AgentConfigQueryResult = Apollo.QueryResult<
  AgentConfigQuery,
  AgentConfigQueryVariables
>;
export const RecommendedForYouContentIdsDocument = gql`
  query RecommendedForYouContentIds {
    careJourneys(filters: { careJourneyTemplateType: PREVENTATIVE }) {
      id
      sequentialTouchpoints(
        touchpointFilters: {
          statusRange: [OPEN, IN_PROGRESS]
          category: [CONTENT]
        }
      ) {
        id
        task {
          id
          relatedObjectId
          relatedObjectType
        }
      }
    }
  }
`;

/**
 * __useRecommendedForYouContentIdsQuery__
 *
 * To run a query within a React component, call `useRecommendedForYouContentIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecommendedForYouContentIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecommendedForYouContentIdsQuery({
 *   variables: {
 *   },
 * });
 */
export function useRecommendedForYouContentIdsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    RecommendedForYouContentIdsQuery,
    RecommendedForYouContentIdsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    RecommendedForYouContentIdsQuery,
    RecommendedForYouContentIdsQueryVariables
  >(RecommendedForYouContentIdsDocument, options);
}
export function useRecommendedForYouContentIdsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RecommendedForYouContentIdsQuery,
    RecommendedForYouContentIdsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    RecommendedForYouContentIdsQuery,
    RecommendedForYouContentIdsQueryVariables
  >(RecommendedForYouContentIdsDocument, options);
}
export type RecommendedForYouContentIdsQueryHookResult = ReturnType<
  typeof useRecommendedForYouContentIdsQuery
>;
export type RecommendedForYouContentIdsLazyQueryHookResult = ReturnType<
  typeof useRecommendedForYouContentIdsLazyQuery
>;
export type RecommendedForYouContentIdsQueryResult = Apollo.QueryResult<
  RecommendedForYouContentIdsQuery,
  RecommendedForYouContentIdsQueryVariables
>;
export const SupportContactInformationDocument = gql`
  query SupportContactInformation($tenantDomain: String!) {
    tenant: tenantByDomain(domain: $tenantDomain) {
      supportEmail
    }
  }
`;

/**
 * __useSupportContactInformationQuery__
 *
 * To run a query within a React component, call `useSupportContactInformationQuery` and pass it any options that fit your needs.
 * When your component renders, `useSupportContactInformationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSupportContactInformationQuery({
 *   variables: {
 *      tenantDomain: // value for 'tenantDomain'
 *   },
 * });
 */
export function useSupportContactInformationQuery(
  baseOptions: Apollo.QueryHookOptions<
    SupportContactInformationQuery,
    SupportContactInformationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    SupportContactInformationQuery,
    SupportContactInformationQueryVariables
  >(SupportContactInformationDocument, options);
}
export function useSupportContactInformationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SupportContactInformationQuery,
    SupportContactInformationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SupportContactInformationQuery,
    SupportContactInformationQueryVariables
  >(SupportContactInformationDocument, options);
}
export type SupportContactInformationQueryHookResult = ReturnType<
  typeof useSupportContactInformationQuery
>;
export type SupportContactInformationLazyQueryHookResult = ReturnType<
  typeof useSupportContactInformationLazyQuery
>;
export type SupportContactInformationQueryResult = Apollo.QueryResult<
  SupportContactInformationQuery,
  SupportContactInformationQueryVariables
>;
export const UserAddressDocument = gql`
  query UserAddress {
    whoAmI {
      id
      addresses {
        city
        line1
        line2
        state
        postalCode
        country
      }
    }
  }
`;

/**
 * __useUserAddressQuery__
 *
 * To run a query within a React component, call `useUserAddressQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserAddressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserAddressQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserAddressQuery(
  baseOptions?: Apollo.QueryHookOptions<
    UserAddressQuery,
    UserAddressQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<UserAddressQuery, UserAddressQueryVariables>(
    UserAddressDocument,
    options
  );
}
export function useUserAddressLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UserAddressQuery,
    UserAddressQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<UserAddressQuery, UserAddressQueryVariables>(
    UserAddressDocument,
    options
  );
}
export type UserAddressQueryHookResult = ReturnType<typeof useUserAddressQuery>;
export type UserAddressLazyQueryHookResult = ReturnType<
  typeof useUserAddressLazyQuery
>;
export type UserAddressQueryResult = Apollo.QueryResult<
  UserAddressQuery,
  UserAddressQueryVariables
>;
export const UserExistsDocument = gql`
  query UserExists {
    whoAmI {
      id
      enrollments {
        id
        programId
      }
    }
  }
`;

/**
 * __useUserExistsQuery__
 *
 * To run a query within a React component, call `useUserExistsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserExistsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserExistsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserExistsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    UserExistsQuery,
    UserExistsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<UserExistsQuery, UserExistsQueryVariables>(
    UserExistsDocument,
    options
  );
}
export function useUserExistsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UserExistsQuery,
    UserExistsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<UserExistsQuery, UserExistsQueryVariables>(
    UserExistsDocument,
    options
  );
}
export type UserExistsQueryHookResult = ReturnType<typeof useUserExistsQuery>;
export type UserExistsLazyQueryHookResult = ReturnType<
  typeof useUserExistsLazyQuery
>;
export type UserExistsQueryResult = Apollo.QueryResult<
  UserExistsQuery,
  UserExistsQueryVariables
>;
export const UserProfileDocument = gql`
  query UserProfile {
    whoAmI {
      id
      firstName
      lastName
      birthDate
      birthSex
      createdAt
      updatedAt
      preferredName
      contactPreference
      genderIdentity {
        text
        value
      }
      phoneNumbers {
        use
        value
      }
      pronouns {
        text
        value
      }
    }
  }
`;

/**
 * __useUserProfileQuery__
 *
 * To run a query within a React component, call `useUserProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserProfileQuery(
  baseOptions?: Apollo.QueryHookOptions<
    UserProfileQuery,
    UserProfileQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<UserProfileQuery, UserProfileQueryVariables>(
    UserProfileDocument,
    options
  );
}
export function useUserProfileLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UserProfileQuery,
    UserProfileQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<UserProfileQuery, UserProfileQueryVariables>(
    UserProfileDocument,
    options
  );
}
export type UserProfileQueryHookResult = ReturnType<typeof useUserProfileQuery>;
export type UserProfileLazyQueryHookResult = ReturnType<
  typeof useUserProfileLazyQuery
>;
export type UserProfileQueryResult = Apollo.QueryResult<
  UserProfileQuery,
  UserProfileQueryVariables
>;
export const WhoAmIDocument = gql`
  query WhoAmI {
    whoAmI {
      id
      firstName
      lastName
      birthDate
      birthSex
      preferredName
      contactPreference
      genderIdentity {
        text
        value
      }
      phoneNumbers {
        use
        value
      }
      emailAddresses {
        value
      }
      pronouns {
        text
        value
      }
      addresses {
        city
        line1
        line2
        state
        postalCode
        country
      }
      member {
        id
        cohort
      }
      enrollments {
        id
        programId
        enrollmentStatus
        program {
          config {
            roleNameMapping
          }
          id
          name
          slug
        }
      }
      careJourneys {
        id
        status
        careJourneyTemplateVersion {
          careJourneyTemplate {
            name
          }
        }
      }
    }
  }
`;

/**
 * __useWhoAmIQuery__
 *
 * To run a query within a React component, call `useWhoAmIQuery` and pass it any options that fit your needs.
 * When your component renders, `useWhoAmIQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWhoAmIQuery({
 *   variables: {
 *   },
 * });
 */
export function useWhoAmIQuery(
  baseOptions?: Apollo.QueryHookOptions<WhoAmIQuery, WhoAmIQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<WhoAmIQuery, WhoAmIQueryVariables>(
    WhoAmIDocument,
    options
  );
}
export function useWhoAmILazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<WhoAmIQuery, WhoAmIQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<WhoAmIQuery, WhoAmIQueryVariables>(
    WhoAmIDocument,
    options
  );
}
export type WhoAmIQueryHookResult = ReturnType<typeof useWhoAmIQuery>;
export type WhoAmILazyQueryHookResult = ReturnType<typeof useWhoAmILazyQuery>;
export type WhoAmIQueryResult = Apollo.QueryResult<
  WhoAmIQuery,
  WhoAmIQueryVariables
>;
export const MarkGuidedJourneyCompleteDocument = gql`
  mutation MarkGuidedJourneyComplete(
    $patientId: UUID!
    $programId: UUID!
    $id: String!
    $guidedJourneyId: String!
    $taskId: UUID = null
  ) {
    createContentView(
      input: {
        patientId: $patientId
        programId: $programId
        contentId: $id
        contentType: PAGE
        parentContentId: $guidedJourneyId
        parentContentType: GUIDED_JOURNEY
        isContentAssignmentComplete: true
        taskId: $taskId
      }
    ) {
      id
      contentId
    }
  }
`;
export type MarkGuidedJourneyCompleteMutationFn = Apollo.MutationFunction<
  MarkGuidedJourneyCompleteMutation,
  MarkGuidedJourneyCompleteMutationVariables
>;

/**
 * __useMarkGuidedJourneyCompleteMutation__
 *
 * To run a mutation, you first call `useMarkGuidedJourneyCompleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkGuidedJourneyCompleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markGuidedJourneyCompleteMutation, { data, loading, error }] = useMarkGuidedJourneyCompleteMutation({
 *   variables: {
 *      patientId: // value for 'patientId'
 *      programId: // value for 'programId'
 *      id: // value for 'id'
 *      guidedJourneyId: // value for 'guidedJourneyId'
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useMarkGuidedJourneyCompleteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MarkGuidedJourneyCompleteMutation,
    MarkGuidedJourneyCompleteMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    MarkGuidedJourneyCompleteMutation,
    MarkGuidedJourneyCompleteMutationVariables
  >(MarkGuidedJourneyCompleteDocument, options);
}
export type MarkGuidedJourneyCompleteMutationHookResult = ReturnType<
  typeof useMarkGuidedJourneyCompleteMutation
>;
export type MarkGuidedJourneyCompleteMutationResult =
  Apollo.MutationResult<MarkGuidedJourneyCompleteMutation>;
export type MarkGuidedJourneyCompleteMutationOptions =
  Apollo.BaseMutationOptions<
    MarkGuidedJourneyCompleteMutation,
    MarkGuidedJourneyCompleteMutationVariables
  >;
export const MarkGuidedJourneyPageReadDocument = gql`
  mutation MarkGuidedJourneyPageRead(
    $patientId: UUID!
    $programId: UUID!
    $id: String!
    $guidedJourneyId: String!
    $taskId: UUID = null
  ) {
    createContentView(
      input: {
        patientId: $patientId
        programId: $programId
        contentId: $id
        contentType: PAGE
        isContentAssignmentComplete: false
        parentContentId: $guidedJourneyId
        parentContentType: GUIDED_JOURNEY
        taskId: $taskId
      }
    ) {
      id
      contentId
    }
  }
`;
export type MarkGuidedJourneyPageReadMutationFn = Apollo.MutationFunction<
  MarkGuidedJourneyPageReadMutation,
  MarkGuidedJourneyPageReadMutationVariables
>;

/**
 * __useMarkGuidedJourneyPageReadMutation__
 *
 * To run a mutation, you first call `useMarkGuidedJourneyPageReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkGuidedJourneyPageReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markGuidedJourneyPageReadMutation, { data, loading, error }] = useMarkGuidedJourneyPageReadMutation({
 *   variables: {
 *      patientId: // value for 'patientId'
 *      programId: // value for 'programId'
 *      id: // value for 'id'
 *      guidedJourneyId: // value for 'guidedJourneyId'
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useMarkGuidedJourneyPageReadMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MarkGuidedJourneyPageReadMutation,
    MarkGuidedJourneyPageReadMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    MarkGuidedJourneyPageReadMutation,
    MarkGuidedJourneyPageReadMutationVariables
  >(MarkGuidedJourneyPageReadDocument, options);
}
export type MarkGuidedJourneyPageReadMutationHookResult = ReturnType<
  typeof useMarkGuidedJourneyPageReadMutation
>;
export type MarkGuidedJourneyPageReadMutationResult =
  Apollo.MutationResult<MarkGuidedJourneyPageReadMutation>;
export type MarkGuidedJourneyPageReadMutationOptions =
  Apollo.BaseMutationOptions<
    MarkGuidedJourneyPageReadMutation,
    MarkGuidedJourneyPageReadMutationVariables
  >;
export const MarkPageReadDocument = gql`
  mutation MarkPageRead(
    $patientId: UUID!
    $programId: UUID!
    $id: String!
    $taskId: UUID = null
    $markTaskComplete: Boolean = false
  ) {
    createContentView(
      input: {
        patientId: $patientId
        programId: $programId
        contentId: $id
        contentType: PAGE
        isContentAssignmentComplete: $markTaskComplete
        taskId: $taskId
      }
    ) {
      id
      contentId
    }
  }
`;
export type MarkPageReadMutationFn = Apollo.MutationFunction<
  MarkPageReadMutation,
  MarkPageReadMutationVariables
>;

/**
 * __useMarkPageReadMutation__
 *
 * To run a mutation, you first call `useMarkPageReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkPageReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markPageReadMutation, { data, loading, error }] = useMarkPageReadMutation({
 *   variables: {
 *      patientId: // value for 'patientId'
 *      programId: // value for 'programId'
 *      id: // value for 'id'
 *      taskId: // value for 'taskId'
 *      markTaskComplete: // value for 'markTaskComplete'
 *   },
 * });
 */
export function useMarkPageReadMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MarkPageReadMutation,
    MarkPageReadMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    MarkPageReadMutation,
    MarkPageReadMutationVariables
  >(MarkPageReadDocument, options);
}
export type MarkPageReadMutationHookResult = ReturnType<
  typeof useMarkPageReadMutation
>;
export type MarkPageReadMutationResult =
  Apollo.MutationResult<MarkPageReadMutation>;
export type MarkPageReadMutationOptions = Apollo.BaseMutationOptions<
  MarkPageReadMutation,
  MarkPageReadMutationVariables
>;
export const UpsertFormResponseByTaskIdDocument = gql`
  mutation UpsertFormResponseByTaskId(
    $taskId: UUID!
    $input: UpsertFormResponseInput!
  ) {
    upsertFormResponseByTaskId(taskId: $taskId, input: $input) {
      id
      patientId
      programId
      formVersionId
      task {
        id
      }
      response
      createdAt
      updatedAt
      submittedAt
      formVersion {
        id
      }
    }
  }
`;
export type UpsertFormResponseByTaskIdMutationFn = Apollo.MutationFunction<
  UpsertFormResponseByTaskIdMutation,
  UpsertFormResponseByTaskIdMutationVariables
>;

/**
 * __useUpsertFormResponseByTaskIdMutation__
 *
 * To run a mutation, you first call `useUpsertFormResponseByTaskIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertFormResponseByTaskIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertFormResponseByTaskIdMutation, { data, loading, error }] = useUpsertFormResponseByTaskIdMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertFormResponseByTaskIdMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpsertFormResponseByTaskIdMutation,
    UpsertFormResponseByTaskIdMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpsertFormResponseByTaskIdMutation,
    UpsertFormResponseByTaskIdMutationVariables
  >(UpsertFormResponseByTaskIdDocument, options);
}
export type UpsertFormResponseByTaskIdMutationHookResult = ReturnType<
  typeof useUpsertFormResponseByTaskIdMutation
>;
export type UpsertFormResponseByTaskIdMutationResult =
  Apollo.MutationResult<UpsertFormResponseByTaskIdMutation>;
export type UpsertFormResponseByTaskIdMutationOptions =
  Apollo.BaseMutationOptions<
    UpsertFormResponseByTaskIdMutation,
    UpsertFormResponseByTaskIdMutationVariables
  >;
export const ResetUserPasswordDocument = gql`
  mutation resetUserPassword($resetUserPasswordId: UUID!) {
    resetUserPassword(id: $resetUserPasswordId)
  }
`;
export type ResetUserPasswordMutationFn = Apollo.MutationFunction<
  ResetUserPasswordMutation,
  ResetUserPasswordMutationVariables
>;

/**
 * __useResetUserPasswordMutation__
 *
 * To run a mutation, you first call `useResetUserPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetUserPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetUserPasswordMutation, { data, loading, error }] = useResetUserPasswordMutation({
 *   variables: {
 *      resetUserPasswordId: // value for 'resetUserPasswordId'
 *   },
 * });
 */
export function useResetUserPasswordMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ResetUserPasswordMutation,
    ResetUserPasswordMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ResetUserPasswordMutation,
    ResetUserPasswordMutationVariables
  >(ResetUserPasswordDocument, options);
}
export type ResetUserPasswordMutationHookResult = ReturnType<
  typeof useResetUserPasswordMutation
>;
export type ResetUserPasswordMutationResult =
  Apollo.MutationResult<ResetUserPasswordMutation>;
export type ResetUserPasswordMutationOptions = Apollo.BaseMutationOptions<
  ResetUserPasswordMutation,
  ResetUserPasswordMutationVariables
>;
export const UpdatePatientDocument = gql`
  mutation updatePatient($updatePatientId: UUID!, $input: UpdatePatientInput!) {
    updatePatient(id: $updatePatientId, input: $input) {
      firstName
    }
  }
`;
export type UpdatePatientMutationFn = Apollo.MutationFunction<
  UpdatePatientMutation,
  UpdatePatientMutationVariables
>;

/**
 * __useUpdatePatientMutation__
 *
 * To run a mutation, you first call `useUpdatePatientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePatientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePatientMutation, { data, loading, error }] = useUpdatePatientMutation({
 *   variables: {
 *      updatePatientId: // value for 'updatePatientId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePatientMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdatePatientMutation,
    UpdatePatientMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdatePatientMutation,
    UpdatePatientMutationVariables
  >(UpdatePatientDocument, options);
}
export type UpdatePatientMutationHookResult = ReturnType<
  typeof useUpdatePatientMutation
>;
export type UpdatePatientMutationResult =
  Apollo.MutationResult<UpdatePatientMutation>;
export type UpdatePatientMutationOptions = Apollo.BaseMutationOptions<
  UpdatePatientMutation,
  UpdatePatientMutationVariables
>;
export const UpsertNotificationProfileDocument = gql`
  mutation UpsertNotificationProfile($input: NotificationProfileInput!) {
    upsertNotificationProfile(input: $input) {
      healthCommunicationsOptPreference {
        email
        sms
      }
    }
  }
`;
export type UpsertNotificationProfileMutationFn = Apollo.MutationFunction<
  UpsertNotificationProfileMutation,
  UpsertNotificationProfileMutationVariables
>;

/**
 * __useUpsertNotificationProfileMutation__
 *
 * To run a mutation, you first call `useUpsertNotificationProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertNotificationProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertNotificationProfileMutation, { data, loading, error }] = useUpsertNotificationProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertNotificationProfileMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpsertNotificationProfileMutation,
    UpsertNotificationProfileMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpsertNotificationProfileMutation,
    UpsertNotificationProfileMutationVariables
  >(UpsertNotificationProfileDocument, options);
}
export type UpsertNotificationProfileMutationHookResult = ReturnType<
  typeof useUpsertNotificationProfileMutation
>;
export type UpsertNotificationProfileMutationResult =
  Apollo.MutationResult<UpsertNotificationProfileMutation>;
export type UpsertNotificationProfileMutationOptions =
  Apollo.BaseMutationOptions<
    UpsertNotificationProfileMutation,
    UpsertNotificationProfileMutationVariables
  >;
export const GuidedJourneyReadPositionDocument = gql`
  query GuidedJourneyReadPosition(
    $patientId: UUID!
    $programId: UUID!
    $guidedJourneyId: String!
    $taskId: UUID = null
  ) {
    contentViews(
      filters: {
        patientId: $patientId
        programId: $programId
        parentContentId: $guidedJourneyId
        taskId: $taskId
        dedupe: true
      }
    ) {
      ...GuidedJourneyReadPositionDetails
    }
  }
  ${GuidedJourneyReadPositionDetailsFragmentDoc}
`;

/**
 * __useGuidedJourneyReadPositionQuery__
 *
 * To run a query within a React component, call `useGuidedJourneyReadPositionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGuidedJourneyReadPositionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGuidedJourneyReadPositionQuery({
 *   variables: {
 *      patientId: // value for 'patientId'
 *      programId: // value for 'programId'
 *      guidedJourneyId: // value for 'guidedJourneyId'
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useGuidedJourneyReadPositionQuery(
  baseOptions: Apollo.QueryHookOptions<
    GuidedJourneyReadPositionQuery,
    GuidedJourneyReadPositionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GuidedJourneyReadPositionQuery,
    GuidedJourneyReadPositionQueryVariables
  >(GuidedJourneyReadPositionDocument, options);
}
export function useGuidedJourneyReadPositionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GuidedJourneyReadPositionQuery,
    GuidedJourneyReadPositionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GuidedJourneyReadPositionQuery,
    GuidedJourneyReadPositionQueryVariables
  >(GuidedJourneyReadPositionDocument, options);
}
export type GuidedJourneyReadPositionQueryHookResult = ReturnType<
  typeof useGuidedJourneyReadPositionQuery
>;
export type GuidedJourneyReadPositionLazyQueryHookResult = ReturnType<
  typeof useGuidedJourneyReadPositionLazyQuery
>;
export type GuidedJourneyReadPositionQueryResult = Apollo.QueryResult<
  GuidedJourneyReadPositionQuery,
  GuidedJourneyReadPositionQueryVariables
>;
export const NotificationProfileDocument = gql`
  query NotificationProfile($patientId: UUID!) {
    patientNotificationProfile(patientId: $patientId) {
      healthCommunicationsOptPreference {
        email
        sms
      }
    }
  }
`;

/**
 * __useNotificationProfileQuery__
 *
 * To run a query within a React component, call `useNotificationProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationProfileQuery({
 *   variables: {
 *      patientId: // value for 'patientId'
 *   },
 * });
 */
export function useNotificationProfileQuery(
  baseOptions: Apollo.QueryHookOptions<
    NotificationProfileQuery,
    NotificationProfileQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    NotificationProfileQuery,
    NotificationProfileQueryVariables
  >(NotificationProfileDocument, options);
}
export function useNotificationProfileLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    NotificationProfileQuery,
    NotificationProfileQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    NotificationProfileQuery,
    NotificationProfileQueryVariables
  >(NotificationProfileDocument, options);
}
export type NotificationProfileQueryHookResult = ReturnType<
  typeof useNotificationProfileQuery
>;
export type NotificationProfileLazyQueryHookResult = ReturnType<
  typeof useNotificationProfileLazyQuery
>;
export type NotificationProfileQueryResult = Apollo.QueryResult<
  NotificationProfileQuery,
  NotificationProfileQueryVariables
>;
export const GetFormByIdDocument = gql`
  query GetFormById($formId: UUID!) {
    form(id: $formId) {
      id
      draftVersion {
        config
        id
      }
      archivedAt
      createdAt
      description
      name
      programId
      publishedVersion {
        config
        id
      }
      slug
      updatedAt
    }
  }
`;

/**
 * __useGetFormByIdQuery__
 *
 * To run a query within a React component, call `useGetFormByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFormByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFormByIdQuery({
 *   variables: {
 *      formId: // value for 'formId'
 *   },
 * });
 */
export function useGetFormByIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetFormByIdQuery,
    GetFormByIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetFormByIdQuery, GetFormByIdQueryVariables>(
    GetFormByIdDocument,
    options
  );
}
export function useGetFormByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetFormByIdQuery,
    GetFormByIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetFormByIdQuery, GetFormByIdQueryVariables>(
    GetFormByIdDocument,
    options
  );
}
export type GetFormByIdQueryHookResult = ReturnType<typeof useGetFormByIdQuery>;
export type GetFormByIdLazyQueryHookResult = ReturnType<
  typeof useGetFormByIdLazyQuery
>;
export type GetFormByIdQueryResult = Apollo.QueryResult<
  GetFormByIdQuery,
  GetFormByIdQueryVariables
>;
export const GetFormResponseByTaskIdDocument = gql`
  query GetFormResponseByTaskId($taskId: UUID!) {
    formResponseByTaskId(taskId: $taskId) {
      id
      response
      pageNumber
    }
  }
`;

/**
 * __useGetFormResponseByTaskIdQuery__
 *
 * To run a query within a React component, call `useGetFormResponseByTaskIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFormResponseByTaskIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFormResponseByTaskIdQuery({
 *   variables: {
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useGetFormResponseByTaskIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetFormResponseByTaskIdQuery,
    GetFormResponseByTaskIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetFormResponseByTaskIdQuery,
    GetFormResponseByTaskIdQueryVariables
  >(GetFormResponseByTaskIdDocument, options);
}
export function useGetFormResponseByTaskIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetFormResponseByTaskIdQuery,
    GetFormResponseByTaskIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetFormResponseByTaskIdQuery,
    GetFormResponseByTaskIdQueryVariables
  >(GetFormResponseByTaskIdDocument, options);
}
export type GetFormResponseByTaskIdQueryHookResult = ReturnType<
  typeof useGetFormResponseByTaskIdQuery
>;
export type GetFormResponseByTaskIdLazyQueryHookResult = ReturnType<
  typeof useGetFormResponseByTaskIdLazyQuery
>;
export type GetFormResponseByTaskIdQueryResult = Apollo.QueryResult<
  GetFormResponseByTaskIdQuery,
  GetFormResponseByTaskIdQueryVariables
>;
export const PatientMemberBenefitsDocument = gql`
  query PatientMemberBenefits($patientId: UUID!) {
    patientMember(patientId: $patientId) {
      id
      additionalBenefits {
        accessCode
        description
        name
        url
      }
    }
  }
`;

/**
 * __usePatientMemberBenefitsQuery__
 *
 * To run a query within a React component, call `usePatientMemberBenefitsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatientMemberBenefitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePatientMemberBenefitsQuery({
 *   variables: {
 *      patientId: // value for 'patientId'
 *   },
 * });
 */
export function usePatientMemberBenefitsQuery(
  baseOptions: Apollo.QueryHookOptions<
    PatientMemberBenefitsQuery,
    PatientMemberBenefitsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PatientMemberBenefitsQuery,
    PatientMemberBenefitsQueryVariables
  >(PatientMemberBenefitsDocument, options);
}
export function usePatientMemberBenefitsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PatientMemberBenefitsQuery,
    PatientMemberBenefitsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PatientMemberBenefitsQuery,
    PatientMemberBenefitsQueryVariables
  >(PatientMemberBenefitsDocument, options);
}
export type PatientMemberBenefitsQueryHookResult = ReturnType<
  typeof usePatientMemberBenefitsQuery
>;
export type PatientMemberBenefitsLazyQueryHookResult = ReturnType<
  typeof usePatientMemberBenefitsLazyQuery
>;
export type PatientMemberBenefitsQueryResult = Apollo.QueryResult<
  PatientMemberBenefitsQuery,
  PatientMemberBenefitsQueryVariables
>;
export const ConceptsPractitionersAutocompleteDocument = gql`
  query ConceptsPractitionersAutocomplete($query: String!) {
    conceptsPractitionersAutocomplete(query: $query) {
      concepts {
        value
        type
        id
      }
      practitioners {
        displayName
        id
      }
    }
  }
`;

/**
 * __useConceptsPractitionersAutocompleteQuery__
 *
 * To run a query within a React component, call `useConceptsPractitionersAutocompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useConceptsPractitionersAutocompleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConceptsPractitionersAutocompleteQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useConceptsPractitionersAutocompleteQuery(
  baseOptions: Apollo.QueryHookOptions<
    ConceptsPractitionersAutocompleteQuery,
    ConceptsPractitionersAutocompleteQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ConceptsPractitionersAutocompleteQuery,
    ConceptsPractitionersAutocompleteQueryVariables
  >(ConceptsPractitionersAutocompleteDocument, options);
}
export function useConceptsPractitionersAutocompleteLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ConceptsPractitionersAutocompleteQuery,
    ConceptsPractitionersAutocompleteQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ConceptsPractitionersAutocompleteQuery,
    ConceptsPractitionersAutocompleteQueryVariables
  >(ConceptsPractitionersAutocompleteDocument, options);
}
export type ConceptsPractitionersAutocompleteQueryHookResult = ReturnType<
  typeof useConceptsPractitionersAutocompleteQuery
>;
export type ConceptsPractitionersAutocompleteLazyQueryHookResult = ReturnType<
  typeof useConceptsPractitionersAutocompleteLazyQuery
>;
export type ConceptsPractitionersAutocompleteQueryResult = Apollo.QueryResult<
  ConceptsPractitionersAutocompleteQuery,
  ConceptsPractitionersAutocompleteQueryVariables
>;
export const FacilitiesNearDocument = gql`
  query FacilitiesNear(
    $filters: FilterNearFacilitiesParams!
    $pagination: PaginationParams
  ) {
    facilitiesNear(filters: $filters, pagination: $pagination) {
      totalCount
      items {
        distance
        facility {
          name
          type
          phoneNumber
          id
        }
        address {
          geoLocation
          accessible
          city
          addressLine2
          addressLine1
          state
          zipCode
        }
      }
    }
  }
`;

/**
 * __useFacilitiesNearQuery__
 *
 * To run a query within a React component, call `useFacilitiesNearQuery` and pass it any options that fit your needs.
 * When your component renders, `useFacilitiesNearQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFacilitiesNearQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useFacilitiesNearQuery(
  baseOptions: Apollo.QueryHookOptions<
    FacilitiesNearQuery,
    FacilitiesNearQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<FacilitiesNearQuery, FacilitiesNearQueryVariables>(
    FacilitiesNearDocument,
    options
  );
}
export function useFacilitiesNearLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FacilitiesNearQuery,
    FacilitiesNearQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<FacilitiesNearQuery, FacilitiesNearQueryVariables>(
    FacilitiesNearDocument,
    options
  );
}
export type FacilitiesNearQueryHookResult = ReturnType<
  typeof useFacilitiesNearQuery
>;
export type FacilitiesNearLazyQueryHookResult = ReturnType<
  typeof useFacilitiesNearLazyQuery
>;
export type FacilitiesNearQueryResult = Apollo.QueryResult<
  FacilitiesNearQuery,
  FacilitiesNearQueryVariables
>;
export const FacilityDocument = gql`
  query Facility($facilityId: UUID!) {
    facility(id: $facilityId) {
      id
      name
      phoneNumber
      accessible
      city
      addressLine1
      addressLine2
      geoLocation
      type
      zipCode
    }
  }
`;

/**
 * __useFacilityQuery__
 *
 * To run a query within a React component, call `useFacilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useFacilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFacilityQuery({
 *   variables: {
 *      facilityId: // value for 'facilityId'
 *   },
 * });
 */
export function useFacilityQuery(
  baseOptions: Apollo.QueryHookOptions<FacilityQuery, FacilityQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<FacilityQuery, FacilityQueryVariables>(
    FacilityDocument,
    options
  );
}
export function useFacilityLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FacilityQuery,
    FacilityQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<FacilityQuery, FacilityQueryVariables>(
    FacilityDocument,
    options
  );
}
export type FacilityQueryHookResult = ReturnType<typeof useFacilityQuery>;
export type FacilityLazyQueryHookResult = ReturnType<
  typeof useFacilityLazyQuery
>;
export type FacilityQueryResult = Apollo.QueryResult<
  FacilityQuery,
  FacilityQueryVariables
>;
export const NetworksDocument = gql`
  query Networks {
    networks {
      id
      name
    }
  }
`;

/**
 * __useNetworksQuery__
 *
 * To run a query within a React component, call `useNetworksQuery` and pass it any options that fit your needs.
 * When your component renders, `useNetworksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNetworksQuery({
 *   variables: {
 *   },
 * });
 */
export function useNetworksQuery(
  baseOptions?: Apollo.QueryHookOptions<NetworksQuery, NetworksQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<NetworksQuery, NetworksQueryVariables>(
    NetworksDocument,
    options
  );
}
export function useNetworksLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    NetworksQuery,
    NetworksQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<NetworksQuery, NetworksQueryVariables>(
    NetworksDocument,
    options
  );
}
export type NetworksQueryHookResult = ReturnType<typeof useNetworksQuery>;
export type NetworksLazyQueryHookResult = ReturnType<
  typeof useNetworksLazyQuery
>;
export type NetworksQueryResult = Apollo.QueryResult<
  NetworksQuery,
  NetworksQueryVariables
>;
export const PatientMemberNetworkIdDocument = gql`
  query PatientMemberNetworkId($patientId: UUID!) {
    patientMember(patientId: $patientId) {
      id
      employer {
        id
        networkId
      }
    }
  }
`;

/**
 * __usePatientMemberNetworkIdQuery__
 *
 * To run a query within a React component, call `usePatientMemberNetworkIdQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatientMemberNetworkIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePatientMemberNetworkIdQuery({
 *   variables: {
 *      patientId: // value for 'patientId'
 *   },
 * });
 */
export function usePatientMemberNetworkIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    PatientMemberNetworkIdQuery,
    PatientMemberNetworkIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PatientMemberNetworkIdQuery,
    PatientMemberNetworkIdQueryVariables
  >(PatientMemberNetworkIdDocument, options);
}
export function usePatientMemberNetworkIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PatientMemberNetworkIdQuery,
    PatientMemberNetworkIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PatientMemberNetworkIdQuery,
    PatientMemberNetworkIdQueryVariables
  >(PatientMemberNetworkIdDocument, options);
}
export type PatientMemberNetworkIdQueryHookResult = ReturnType<
  typeof usePatientMemberNetworkIdQuery
>;
export type PatientMemberNetworkIdLazyQueryHookResult = ReturnType<
  typeof usePatientMemberNetworkIdLazyQuery
>;
export type PatientMemberNetworkIdQueryResult = Apollo.QueryResult<
  PatientMemberNetworkIdQuery,
  PatientMemberNetworkIdQueryVariables
>;
export const PatientMemberWrapNetworkDocument = gql`
  query PatientMemberWrapNetwork($patientId: UUID!) {
    patientMember(patientId: $patientId) {
      employer {
        wrapNetworkUrl
        wrapNetworkName
      }
    }
  }
`;

/**
 * __usePatientMemberWrapNetworkQuery__
 *
 * To run a query within a React component, call `usePatientMemberWrapNetworkQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatientMemberWrapNetworkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePatientMemberWrapNetworkQuery({
 *   variables: {
 *      patientId: // value for 'patientId'
 *   },
 * });
 */
export function usePatientMemberWrapNetworkQuery(
  baseOptions: Apollo.QueryHookOptions<
    PatientMemberWrapNetworkQuery,
    PatientMemberWrapNetworkQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PatientMemberWrapNetworkQuery,
    PatientMemberWrapNetworkQueryVariables
  >(PatientMemberWrapNetworkDocument, options);
}
export function usePatientMemberWrapNetworkLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PatientMemberWrapNetworkQuery,
    PatientMemberWrapNetworkQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PatientMemberWrapNetworkQuery,
    PatientMemberWrapNetworkQueryVariables
  >(PatientMemberWrapNetworkDocument, options);
}
export type PatientMemberWrapNetworkQueryHookResult = ReturnType<
  typeof usePatientMemberWrapNetworkQuery
>;
export type PatientMemberWrapNetworkLazyQueryHookResult = ReturnType<
  typeof usePatientMemberWrapNetworkLazyQuery
>;
export type PatientMemberWrapNetworkQueryResult = Apollo.QueryResult<
  PatientMemberWrapNetworkQuery,
  PatientMemberWrapNetworkQueryVariables
>;
export const PractitionerDocument = gql`
  query Practitioner($practitionerId: UUID!) {
    practitioner(id: $practitionerId) {
      id
      lastName
      firstName
      title
      suffix
      languages
      genderIdentity {
        text
        value
      }
      specialties {
        primary
        id
        boardCertified
        specialty {
          name
        }
      }
      addresses {
        name
        telemedicineCapable
        acceptingNewPatients
        addressLine1
        addressLine2
        city
        schedulingUrl
        geoLocation
        phone
        zipCode
      }
    }
  }
`;

/**
 * __usePractitionerQuery__
 *
 * To run a query within a React component, call `usePractitionerQuery` and pass it any options that fit your needs.
 * When your component renders, `usePractitionerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePractitionerQuery({
 *   variables: {
 *      practitionerId: // value for 'practitionerId'
 *   },
 * });
 */
export function usePractitionerQuery(
  baseOptions: Apollo.QueryHookOptions<
    PractitionerQuery,
    PractitionerQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PractitionerQuery, PractitionerQueryVariables>(
    PractitionerDocument,
    options
  );
}
export function usePractitionerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PractitionerQuery,
    PractitionerQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PractitionerQuery, PractitionerQueryVariables>(
    PractitionerDocument,
    options
  );
}
export type PractitionerQueryHookResult = ReturnType<
  typeof usePractitionerQuery
>;
export type PractitionerLazyQueryHookResult = ReturnType<
  typeof usePractitionerLazyQuery
>;
export type PractitionerQueryResult = Apollo.QueryResult<
  PractitionerQuery,
  PractitionerQueryVariables
>;
export const PractitionersNearDocument = gql`
  query PractitionersNear(
    $filters: FilterNearPractitionerParams!
    $pagination: PaginationParams
  ) {
    practitionersNear(filters: $filters, pagination: $pagination) {
      totalCount
      items {
        distance
        address {
          id
          addressLine1
          addressLine2
          city
          phone
          zipCode
          schedulingUrl
        }
        practitioner {
          id
          firstName
          lastName
          title
          suffix
          specialties {
            primary
            specialty {
              name
            }
          }
          addresses {
            id
            addressLine1
            addressLine2
            city
            phone
            zipCode
            schedulingUrl
            geoLocation
          }
        }
      }
    }
  }
`;

/**
 * __usePractitionersNearQuery__
 *
 * To run a query within a React component, call `usePractitionersNearQuery` and pass it any options that fit your needs.
 * When your component renders, `usePractitionersNearQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePractitionersNearQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function usePractitionersNearQuery(
  baseOptions: Apollo.QueryHookOptions<
    PractitionersNearQuery,
    PractitionersNearQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PractitionersNearQuery,
    PractitionersNearQueryVariables
  >(PractitionersNearDocument, options);
}
export function usePractitionersNearLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PractitionersNearQuery,
    PractitionersNearQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PractitionersNearQuery,
    PractitionersNearQueryVariables
  >(PractitionersNearDocument, options);
}
export type PractitionersNearQueryHookResult = ReturnType<
  typeof usePractitionersNearQuery
>;
export type PractitionersNearLazyQueryHookResult = ReturnType<
  typeof usePractitionersNearLazyQuery
>;
export type PractitionersNearQueryResult = Apollo.QueryResult<
  PractitionersNearQuery,
  PractitionersNearQueryVariables
>;
export const SpecialtyDocument = gql`
  query Specialty($specialtyId: UUID!) {
    specialty(id: $specialtyId) {
      name
      id
    }
  }
`;

/**
 * __useSpecialtyQuery__
 *
 * To run a query within a React component, call `useSpecialtyQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpecialtyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpecialtyQuery({
 *   variables: {
 *      specialtyId: // value for 'specialtyId'
 *   },
 * });
 */
export function useSpecialtyQuery(
  baseOptions: Apollo.QueryHookOptions<SpecialtyQuery, SpecialtyQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SpecialtyQuery, SpecialtyQueryVariables>(
    SpecialtyDocument,
    options
  );
}
export function useSpecialtyLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SpecialtyQuery,
    SpecialtyQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SpecialtyQuery, SpecialtyQueryVariables>(
    SpecialtyDocument,
    options
  );
}
export type SpecialtyQueryHookResult = ReturnType<typeof useSpecialtyQuery>;
export type SpecialtyLazyQueryHookResult = ReturnType<
  typeof useSpecialtyLazyQuery
>;
export type SpecialtyQueryResult = Apollo.QueryResult<
  SpecialtyQuery,
  SpecialtyQueryVariables
>;
export const TaskDocument = gql`
  query Task($taskId: UUID!) {
    task(id: $taskId) {
      id
      eventDueAt
    }
  }
`;

/**
 * __useTaskQuery__
 *
 * To run a query within a React component, call `useTaskQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskQuery({
 *   variables: {
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useTaskQuery(
  baseOptions: Apollo.QueryHookOptions<TaskQuery, TaskQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TaskQuery, TaskQueryVariables>(TaskDocument, options);
}
export function useTaskLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<TaskQuery, TaskQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TaskQuery, TaskQueryVariables>(
    TaskDocument,
    options
  );
}
export type TaskQueryHookResult = ReturnType<typeof useTaskQuery>;
export type TaskLazyQueryHookResult = ReturnType<typeof useTaskLazyQuery>;
export type TaskQueryResult = Apollo.QueryResult<TaskQuery, TaskQueryVariables>;
export const TaskObjectRouteDocument = gql`
  query TaskObjectRoute($taskId: UUID!) {
    task(id: $taskId) {
      id
      name
      status
      taskDueAt
      taskExpireAt
      taskType
      relatedObjectType
      relatedObjectId
    }
  }
`;

/**
 * __useTaskObjectRouteQuery__
 *
 * To run a query within a React component, call `useTaskObjectRouteQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskObjectRouteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskObjectRouteQuery({
 *   variables: {
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useTaskObjectRouteQuery(
  baseOptions: Apollo.QueryHookOptions<
    TaskObjectRouteQuery,
    TaskObjectRouteQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TaskObjectRouteQuery, TaskObjectRouteQueryVariables>(
    TaskObjectRouteDocument,
    options
  );
}
export function useTaskObjectRouteLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TaskObjectRouteQuery,
    TaskObjectRouteQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    TaskObjectRouteQuery,
    TaskObjectRouteQueryVariables
  >(TaskObjectRouteDocument, options);
}
export type TaskObjectRouteQueryHookResult = ReturnType<
  typeof useTaskObjectRouteQuery
>;
export type TaskObjectRouteLazyQueryHookResult = ReturnType<
  typeof useTaskObjectRouteLazyQuery
>;
export type TaskObjectRouteQueryResult = Apollo.QueryResult<
  TaskObjectRouteQuery,
  TaskObjectRouteQueryVariables
>;
export const TenantPoliciesDocument = gql`
  query TenantPolicies($domain: String!) {
    tenant: tenantByDomain(domain: $domain) {
      id
      policiesConfig {
        slug
        url
      }
    }
  }
`;

/**
 * __useTenantPoliciesQuery__
 *
 * To run a query within a React component, call `useTenantPoliciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTenantPoliciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTenantPoliciesQuery({
 *   variables: {
 *      domain: // value for 'domain'
 *   },
 * });
 */
export function useTenantPoliciesQuery(
  baseOptions: Apollo.QueryHookOptions<
    TenantPoliciesQuery,
    TenantPoliciesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TenantPoliciesQuery, TenantPoliciesQueryVariables>(
    TenantPoliciesDocument,
    options
  );
}
export function useTenantPoliciesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TenantPoliciesQuery,
    TenantPoliciesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TenantPoliciesQuery, TenantPoliciesQueryVariables>(
    TenantPoliciesDocument,
    options
  );
}
export type TenantPoliciesQueryHookResult = ReturnType<
  typeof useTenantPoliciesQuery
>;
export type TenantPoliciesLazyQueryHookResult = ReturnType<
  typeof useTenantPoliciesLazyQuery
>;
export type TenantPoliciesQueryResult = Apollo.QueryResult<
  TenantPoliciesQuery,
  TenantPoliciesQueryVariables
>;
export const TimelineTouchpointsDocument = gql`
  query TimelineTouchpoints(
    $pastTouchpointsFilters: FilterSequentialTouchpointParams!
    $pastTouchpointsPagination: PaginationParams
    $pastTouchpointsSorting: [SortTouchpointParam!]
    $currentTouchpointsFilters: FilterSequentialTouchpointParams!
    $currentTouchpointsPagination: PaginationParams
    $currentTouchpointsSorting: [SortTouchpointParam!]
    $incomingTouchpointsFilters: FilterSequentialTouchpointParams!
    $incomingTouchpointsPagination: PaginationParams
    $incomingTouchpointsSorting: [SortTouchpointParam!]
  ) {
    pastTouchpoints: sequentialTouchpoints(
      filters: $pastTouchpointsFilters
      pagination: $pastTouchpointsPagination
      sorting: $pastTouchpointsSorting
    ) {
      items {
        ...TouchpointDetail
      }
      totalCount
    }
    currentTouchpoints: sequentialTouchpoints(
      filters: $currentTouchpointsFilters
      pagination: $currentTouchpointsPagination
      sorting: $currentTouchpointsSorting
    ) {
      items {
        ...TouchpointDetail
      }
      totalCount
    }
    incomingTouchpoints: sequentialTouchpoints(
      filters: $incomingTouchpointsFilters
      pagination: $incomingTouchpointsPagination
      sorting: $incomingTouchpointsSorting
    ) {
      items {
        ...TouchpointDetail
      }
      totalCount
    }
  }
  ${TouchpointDetailFragmentDoc}
`;

/**
 * __useTimelineTouchpointsQuery__
 *
 * To run a query within a React component, call `useTimelineTouchpointsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimelineTouchpointsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimelineTouchpointsQuery({
 *   variables: {
 *      pastTouchpointsFilters: // value for 'pastTouchpointsFilters'
 *      pastTouchpointsPagination: // value for 'pastTouchpointsPagination'
 *      pastTouchpointsSorting: // value for 'pastTouchpointsSorting'
 *      currentTouchpointsFilters: // value for 'currentTouchpointsFilters'
 *      currentTouchpointsPagination: // value for 'currentTouchpointsPagination'
 *      currentTouchpointsSorting: // value for 'currentTouchpointsSorting'
 *      incomingTouchpointsFilters: // value for 'incomingTouchpointsFilters'
 *      incomingTouchpointsPagination: // value for 'incomingTouchpointsPagination'
 *      incomingTouchpointsSorting: // value for 'incomingTouchpointsSorting'
 *   },
 * });
 */
export function useTimelineTouchpointsQuery(
  baseOptions: Apollo.QueryHookOptions<
    TimelineTouchpointsQuery,
    TimelineTouchpointsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    TimelineTouchpointsQuery,
    TimelineTouchpointsQueryVariables
  >(TimelineTouchpointsDocument, options);
}
export function useTimelineTouchpointsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TimelineTouchpointsQuery,
    TimelineTouchpointsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    TimelineTouchpointsQuery,
    TimelineTouchpointsQueryVariables
  >(TimelineTouchpointsDocument, options);
}
export type TimelineTouchpointsQueryHookResult = ReturnType<
  typeof useTimelineTouchpointsQuery
>;
export type TimelineTouchpointsLazyQueryHookResult = ReturnType<
  typeof useTimelineTouchpointsLazyQuery
>;
export type TimelineTouchpointsQueryResult = Apollo.QueryResult<
  TimelineTouchpointsQuery,
  TimelineTouchpointsQueryVariables
>;
